module.exports = __webpack_public_path__ + "static/media/verified.c9a1728d.svg";